import clsx from 'clsx';

import classes from '../../styles/left-pane.module.css';

interface Props {
  onToggle: () => void;
  toggled: boolean;
}

const TopLevelAssetFilterToggle = ({ toggled, onToggle }: Props) => {
  return (
    <div className={classes.assetFilterToggleContainer}>
      <div
        className={clsx(
          classes.assetFilterBox,
          classes.allInventory,
          toggled && classes.selected,
        )}
        onClick={onToggle}
      >
        Inventory Info
      </div>
      <div
        className={clsx(classes.assetFilterBox, !toggled && classes.selected)}
        onClick={onToggle}
      >
        Inventory + Sub Items
      </div>
    </div>
  );
};

export default TopLevelAssetFilterToggle;
